import { shallowMount } from "@vue/test-utils";
import CustomLink from "@/components/core/CustomLink";

describe("CustomLink test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(CustomLink);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component CustomLink", () => {
    expect(wrapper).toBeDefined();
  });
});
